// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2zOxv","title":"InfoRow_title__38gcp"};